<mat-selection-list [multiple]="false">
    <mat-list-option *ngFor="let group of groups" [value]="group" (click)="select(group)">
      {{group.groupName}}
    </mat-list-option>
</mat-selection-list>